import { Flex, Text } from "@jsq/ds/core";
import { ComplianceObjectType } from "~/graphql/supergraphEnums";
import * as styles from "./styles_vanilla.css";
import { SummaryCard } from "./SummaryCard";
import type { WizardCaseInfo } from "../types";

const PROFILE_HEADER: Record<ComplianceObjectType, string> = {
  [ComplianceObjectType.Individual]: "Profile: New individual",
  [ComplianceObjectType.Institution]: "Profile: New entity",
  [ComplianceObjectType.Joint]: "Profile: New joint ownership",
};

interface Props {
  caseInfo: WizardCaseInfo;
  category?: ComplianceObjectType;
  onBack: () => void;
  onEdit?: () => void;
}

const Row = ({ label, value }: { label: string; value: string }) => (
  <Flex gap={20} alignItems="flex-start" className={styles.descriptionRow}>
    <Text variant="secondary-md" className={styles.descriptionLabel}>
      {label}
    </Text>
    <Text variant="regular-md" className={styles.descriptionValue}>
      {value}
    </Text>
  </Flex>
);

export const CaseInfoSummaryCard = ({ caseInfo, category, onBack, onEdit }: Props) => (
  <SummaryCard
    title="Case information"
    backLabel={category ? PROFILE_HEADER[category] : undefined}
    onBack={onBack}
    onEdit={onEdit}
  >
    <Flex flexDirection="column">
      <Row
        label="Prospect ID or subscription URL?"
        value={caseInfo.prospectIdOrSubscriptionUrl ? "Yes" : "No"}
      />
      <Row label="Client" value={caseInfo.clientName ?? "—"} />
      <Row label="Entity" value={caseInfo.entityName ?? "—"} />
      <Row label="Assigned to" value={caseInfo.assignToMyself ? "Myself" : "Unassigned"} />
    </Flex>
  </SummaryCard>
);
